<ng-progress
  #progressBar
  [spinner]="false"
  [min]="10"
  [max]="100"
></ng-progress>
<mat-sidenav-container *ngIf="!isAuthenticated">
  <div class="login-container tw-mt-16 tw-pb-5">
    <div class="tw-flex tw-flex-col tw-justify-center tw-items-center">
      <div class="tw-row tw-flex tw-flex-col tw-items-center">
        <img
          src="./assets/logo.png"
          width="80"
          class="img-logo tw-row"
          alt="sb filter"
        />
        <h1>S&B Filters</h1>
      </div>

      <mat-card class="card-login">
        <mat-card-header class="title">
          <mat-card-title><h1>Iniciar sesión</h1></mat-card-title>
        </mat-card-header>
        <div class="tw-px-3 tw-w-full">
          <button
            mat-raised-button
            (click)="loginRedirect()"
            class="btn-login tw-w-full"
            type="submit"
            color="primary"
            style="background-color: #263238 !important"
          >
            Iniciar
          </button>
        </div>
      </mat-card>
    </div>
  </div>
</mat-sidenav-container>
